import api from '../../utils/axios';

const clientByUserID = async (userId, populate) => {
  const { data } = await api.get(
    `/clients?search[userId]=${userId}${populate ? '&populate=true' : ''}`
  );

  return data;
};

const clientByEmail = async (email) => {
  const { data } = await api.get(`/clients/emails/${email}`);

  return data;
};

const checkForEmail = async (email) => {
  const { data } = await api.get(`/clients/check-email/${email}`);

  return data;
};

const createUserForClient = async (id, password) => {
  const { data } = await api.post(`/clients/users/${id}`, { password });

  return data;
};

const updateClientByID = async (clientId, fields) => {
  const { data } = await api.patch(`/clients/${clientId}`, fields);

  return data;
};

const expertByUserID = async (userId, populate) => {
  const { data } = await api.get(
    `/experts?search[userId]=${userId}${populate ? '&populate=true' : ''}`
  );

  return data;
};

const expertByID = async (id, populate) => {
  const { data } = await api.get(
    `/experts?search[id]=${id}${populate ? '&populate=true' : ''}`
  );

  return data;
};

const clientsByIDs = async (clientsIDs, populate) => {
  let query = '';

  clientsIDs.forEach((clientId) => {
    if (query !== '') query += '&';

    query += `search[id]=${clientId}`;
  });

  const { data } = await api.get(
    `/clients?${query}${populate ? '&populate=true' : ''}`
  );

  return data;
};

const expertCheckout = async (expertId) => {
  const { data } = await api.get(`/experts/${expertId}/checkout`);

  return data;
};

const expertVerifyCheckout = async (expertId, checkoutId) => {
  const { data } = await api.get(`/experts/${expertId}/checkout/${checkoutId}`);

  return data;
};

const expertPayment = async (expertId) => {
  const { data } = await api.get(`/experts/${expertId}/payment`);

  return data;
};

const createExpertCommission = async (
  clientExpertRelationshipId,
  nextAt,
  paymentPeriod
) => {
  const { data } = await api.post(`/expert-commissions`, {
    clientExpertRelationshipId,
    createdAt: new Date().toISOString(),
    nextAt,
    paymentPeriod,
  });

  return data;
};

const expertCommissionByRelationId = async (clientExpertRelationshipId) => {
  const { data } = await api.get(
    `/expert-commissions?search[clientExpertRelationshipId]=${clientExpertRelationshipId}`
  );

  return data;
};

const expertInvoiceByCommissionId = async (expertCommissionId) => {
  const { data } = await api.get(
    `/expert-invoices/expert-commissions/${expertCommissionId}`
  );

  return data;
};

const createExpertInvoice = async (
  expertId,
  expertCommissionId,
  clientAmount,
  expertInvoices
) => {
  const { data } = await api.post(`/expert-invoices/${expertId}`, {
    expertCommissionId,
    clientAmount,
    expertInvoices,
  });

  return data;
};

const expertInvoicePayd = async (expertInvoiceid) => {
  const { data } = await api.get(`/expert-invoices/${expertInvoiceid}/payd`);

  return data;
};

const expertUpdatePayment = async (expertCommissionId) => {
  const { data } = await api.get(
    `/expert-commissions/${expertCommissionId}/update`
  );

  return data;
};

const expertInvoicesUrl = async (invoiceIds) => {
  let ids = '';

  invoiceIds.forEach((id) => {
    if (ids === '') ids += `search[id]=${id}`;
    else ids += `&search[id]=${id}`;
  });

  const { data } = await api.get(`/expert-invoices/list/search?${ids}`);

  return data;
};

const updateExpertByID = async (expertId, fields) => {
  const { data } = await api.patch(`/experts/${expertId}`, fields);

  return data;
};

const createExpertStripeCustomer = async (expertId) => {
  const { data } = await api.post(`/experts/stripe-customer`, {
    id: expertId,
  });

  return data;
};

const profileService = {
  clientByUserID,
  clientByEmail,
  expertByUserID,
  expertByID,
  clientsByIDs,
  expertCheckout,
  expertPayment,
  expertVerifyCheckout,
  createExpertCommission,
  createExpertInvoice,
  checkForEmail,
  expertInvoiceByCommissionId,
  expertInvoicePayd,
  expertUpdatePayment,
  expertInvoicesUrl,
  updateClientByID,
  updateExpertByID,
  expertCommissionByRelationId,
  createExpertStripeCustomer,
  createUserForClient,
};

export default profileService;
